import { render, staticRenderFns } from "./AppraisalDetails.vue?vue&type=template&id=16cc6705&"
import script from "./AppraisalDetails.vue?vue&type=script&lang=js&"
export * from "./AppraisalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports